"use client";
import React, { useLayoutEffect, useState } from "react";
import Image from "next/image";
import { Box, Divider, Container, Button } from "@mui/material";

import { OperatorDetail } from "@/interfaces/ICruisesOperators";
import { getCruiseOperators } from "@/services/backOffice";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Autoplay } from "swiper/modules";

import WavesIcon from "@mui/icons-material/WavesRounded";
import OpenTabIcon from "@mui/icons-material/OpenInNewRounded";

const CruiseLinesOperators = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [operatorData, setOperatorData] = useState<OperatorDetail[]>([]);

  useLayoutEffect(() => {
    async function operatorMGM() {
      try {
        const { data } = await getCruiseOperators(45, 1, true, "300x");
        setOperatorData(data?.operatorDetails ?? []);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    }
    operatorMGM();
  }, []);

  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <Box
          sx={{
            mb: { xs: "0rem", sm: "2rem", md: "0rem" },
            position: "relative",
            zIndex: 3,
            bgcolor: "#FFCEE0aa",
          }}
        >
          <Box sx={{ mt: { xs: "0rem", md: "3rem" }, mb: { xs: "20px", md: "2rem" } }}>
            <Container>
              <Divider
                sx={{
                  "&::before": {
                    borderColor: "#93003680",
                  },
                  "&::after": {
                    borderColor: "#93003680",
                  },
                  mt: { xs: "10px", md: "1.2rem" },
                  mb: { xs: "0px", md: "8px" },
                }}
              >
                <Box
                  sx={{
                    fontFamily: "'blauerNue', 'blauerNue Fallback'",
                    fontSize: { xs: "14px", sm: "20px", lg: "25px" },
                    color: "#930036",
                    fontWeight: 700,
                    textAlign: "center",
                    mb: { xs: "0px", md: "-10px" },
                  }}
                >
                  <Box
                    sx={{
                      display: { xs: "none", sm: "flex" },
                      alignItems: "center",
                      gap: "8px",
                      mx: { xs: "0px", md: "4px" },
                      mt: { xs: "0px", md: "-11px" },
                      svg: {
                        width: "25px",
                        height: "25px",
                      },
                    }}
                  >
                    <WavesIcon />
                    <Box sx={{}}>Top Cruise Companies to Board </Box>
                    <WavesIcon />
                  </Box>

                  <Box
                    sx={{
                      display: { xs: "block", sm: "none" },
                      fontFamily: "'blauerNue', 'blauerNue Fallback'",
                      fontSize: { xs: "20px", md: "20px" },
                      color: "#930036",
                      fontWeight: 700,
                      textAlign: "center",
                    }}
                  >
                    Cruise Lines We Love
                  </Box>
                </Box>
              </Divider>
            </Container>

            <Box sx={{ maxWidth: "100vw" }}>
              <Box
                sx={{
                  position: "relative",
                  ".swiper-wrapper": {
                    transitionTimingFunction: "linear",
                  },
                  ".swiper-slide": {
                    width: "fit-content !important",
                    flexShrink: "100 !important",
                  },
                }}
              >
                <Swiper
                  modules={[FreeMode, Autoplay]}
                  freeMode={true}
                  loop={true}
                  autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                  }}
                  slidesPerView="auto"
                  spaceBetween={20}
                  speed={5000}
                >
                  {!!operatorData &&
                    operatorData.length > 0 &&
                    operatorData.map((operator, oI) => (
                      <SwiperSlide key={oI}>
                        <Box
                          sx={{
                            height: "150px",
                            border: "1px solid #E3005370",
                            boxShadow: "0px 0px 14px #E3005370",
                            m: "10px 0px",
                            p: "10px 15px",
                            bgcolor: "#fff",
                            borderRadius: "15px",
                            display: "grid",
                            placeItems: "center",
                            img: {
                              objectFit: "contain",
                              width: "auto",
                              height: "100px",
                              maxHeight: "80px",
                              maxWidth: "250px",
                              borderRadius: "4px",
                              display: "flex",
                              mb: "10px",
                              textAlign: "center",
                              filter: "saturate(120%)",
                            },
                          }}
                        >
                          <Box sx={{ display: "grid", placeItems: "center" }}>
                            <Image
                              src={operator?.profileImageHref}
                              alt={operator?.title}
                              width={100}
                              height={70}
                              loader={({ src }) => src}
                            />

                            <Box
                              sx={{
                                fontSize: "11px",
                                color: "#444",
                                fontWeight: 300,
                                textAlign: "center",
                              }}
                            >
                              {operator?.title}
                            </Box>
                          </Box>
                        </Box>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </Box>

              <Box
                sx={{
                  display: { xs: "grid", md: "none" },
                  placeItems: "center",
                  mt: "16px",
                  mb: "20px",
                }}
              >
                <Button
                  href="/best-cruise-lines"
                  sx={{
                    width: "fit-content",
                    borderRadius: "20px",
                    textTransform: "initial",
                    gap: "10px",
                    fontSize: "16px",
                    bgcolor: "#930036",
                  }}
                >
                  Explore all Cruise Lines
                  <OpenTabIcon sx={{ width: "25px", height: "25px" }} />
                </Button>
              </Box>
            </Box>
          </Box>

          <Container sx={{}}>
            <Divider
              sx={{ borderColor: "#93003680", mt: { xs: "0px", md: "-10px" }, mb: "-10px" }}
            />
          </Container>
        </Box>
      )}
    </>
  );
};

export default CruiseLinesOperators;
